import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../config/queryClient';
import { apiService } from '../services/apiService';
import { OwnershipScope } from '../types/favourites';
import { getNextEventsRange } from '../utils/nextEventsRange';

export function useNextEvents(
  includeWarrants: boolean = false,
  ownershipScope: OwnershipScope = 'group'
) {
  const range = getNextEventsRange();

  const query = useQuery({
    queryKey: queryKeys.events.upcoming(
      range.fromDate,
      range.toDate,
      includeWarrants,
      ownershipScope
    ),
    queryFn: () =>
      apiService.getEventsListRange(
        range.fromDate,
        range.toDate,
        includeWarrants,
        ownershipScope
      ),
    staleTime: 2 * 60 * 1000,
  });

  const events = [...(query.data ?? [])].sort((left, right) => {
    const dateCompare = String(left.eventDate).localeCompare(String(right.eventDate));
    if (dateCompare !== 0) {
      return dateCompare;
    }
    return (left.sortPriority || 0) - (right.sortPriority || 0);
  });

  return {
    events,
    range,
    isLoading: query.isLoading,
    isError: query.isError,
  };
}
